import { Descriptions } from 'antd';
import { useMemo, VFC } from 'react';
import { UploadFile } from 'antd/lib/upload/interface';
import { FormattedMessage, useIntl } from 'react-intl';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { useStore } from '../../useStore';
import { ImageUploadReview } from '../../../../components/ImageUpload/ImageUploadReview';
import { getPhotoConfigs } from '../../const/config/photo';
import { PhotoDescriptions as messages } from './messages';

export const PhotoDescriptions: VFC<{ enmonMeter: SerializedMeter }> = ({ enmonMeter }) => {
  type InstallationMeterStoreKey = keyof typeof store;
  const store = useStore();
  const intl = useIntl();

  const config = useMemo(() => getPhotoConfigs(intl, enmonMeter), [intl, enmonMeter]);

  return (
    <Descriptions bordered column={1} size="small" title={<FormattedMessage {...messages.title} />}>
      {config.map(reviewSliceConfig => {
        const { label, formItemName } = reviewSliceConfig;
        const fileList = store[formItemName as InstallationMeterStoreKey] as UploadFile<unknown>[] | undefined;
        return (
          <Descriptions.Item key={formItemName} label={label} span={1}>
            <ImageUploadReview fileList={fileList} />
          </Descriptions.Item>
        );
      })}
    </Descriptions>
  );
};
